import axios from 'axios';
import _ from 'lodash';
import config from '@/config/env-constants';

export default {

    paginateAssets(page, limit, startAt, direction, filters, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/paginateAssets`;
        return axios.post(url, { ...filters, page, limit, startAt, direction, currUserId });
    },

    getAssets(filterBy, view, currUserId, pagination = {}) {
        let url = `${config.cloudFunctionsBaseUrl}/getAssets`;
        return axios.post(url, {
            currUserId: currUserId,
            view: view,
            filterBy: JSON.stringify(filterBy),
            search: pagination.search,
            page: pagination.page,
            pageSize: pagination.pageSize,
        });
    },

    activateAssets(param) {
        let url = `${config.cloudFunctionsBaseUrl}/activateAssets`;
        return axios.post(url, {
            currUserId: param.currUserId,
            dateActivated: param.dateActivated,
            operation: param.operation,
            currentLocation: JSON.stringify(param.currentLocation),
            assetCodes: _.join(param.assetCodes, ','),
            assetConditions: JSON.stringify(param.assetConditions)
        });
    },

    markAsLostAssets(param) {
        let url = `${config.cloudFunctionsBaseUrl}/markAsLostAssets`;
        return axios.post(url, {
            currUserId: param.currUserId,
            dateDeactivated: param.dateDeactivated,
            currentLocation: JSON.stringify(param.currentLocation),
            assetCodes: _.join(param.assetCodes, ',')
        });
    },

    changeAssetsLocation(param) {
        let url = `${config.cloudFunctionsBaseUrl}/changeAssetsLocation`;
        return axios.post(url, {
            currUserId: param.currUserId,
            dateUpdated: param.dateUpdated,
            operation: param.operation,
            currCompanyId: param.currCompanyId,
            newLocation: JSON.stringify(param.newLocation),
            assetCodes: _.join(param.assetCodes, ',')
        });
    },

    updateAssets(param) {
        let url = `${config.cloudFunctionsBaseUrl}/updateAssets`;
        return axios.post(url, {
            currUserId: param.currUserId,
            currTimeStamp: param.currTimeStamp,
            assets: JSON.stringify(param.assets)
        });
    },

    getCompanyAssetPools(currUserId, view, filterBy) {
        let url = `${config.cloudFunctionsBaseUrl}/getCompanyAssetPools`;
        return axios.post(url, {
            currUserId: currUserId,
            view: view,
            filterBy: JSON.stringify(filterBy)
        });
    }
}

